// Google returns calendar dates in the customer's time zone, stored as UTC midnight in our cache.
export function googleAdsDateRange(days: number, timeZone = 'UTC', now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
  const part = (name: string) => parts.find((p) => p.type === name)!.value;
  const to = `${part('year')}-${part('month')}-${part('day')}`;
  const start = new Date(`${to}T00:00:00Z`);
  start.setUTCDate(start.getUTCDate() - (days - 1));
  return { from: start.toISOString().slice(0, 10), to };
}

export function reportSyncKey(accountUid: string, customerId: string, level: string, days: number) {
  return `slightercrm.googleAds.report.${accountUid}.${customerId}.${level}.${days}.syncedAt`;
}

export function csvCell(value: string | number): string {
  const text = String(value);
  const safe = typeof value === 'string' && /^[=+@\-\t\r\n]/.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
}
